export default "__VITE_ASSET__fpEzSOLt__"